import { ReactElement } from 'react';

import { styled, TextFieldProps } from '@mui/material';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

import { removeTheseProps } from '@/utils';
import { CustomTextField } from './custom/CustomTextField';

type CustomRightTextFieldProps = TextFieldProps & {
  rightAlignValue?: boolean;
};

const CustomRightTextField = styled(CustomTextField, {
  shouldForwardProp: removeTheseProps<CustomRightTextFieldProps>('rightAlignValue'),
})<CustomRightTextFieldProps>(({ rightAlignValue = true }) => ({
  '& .MuiInputBase-input': {
    textAlign: rightAlignValue ? 'right' : 'unset',
  },
}));

type CustomNumericFormatProps = Omit<
  NumericFormatProps<CustomRightTextFieldProps>,
  'customInput'
>;

export const CustomNumericFormat = (
  props: CustomNumericFormatProps,
): ReactElement => {
  return <NumericFormat customInput={CustomRightTextField} {...props} />;
};
